<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Editing Scoring Item</h4>
    <button mat-button [mat-dialog-close]="" (click)="close()" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form mat-dialog-content [formGroup]="myGroup">
    <mat-form-field class="score-name" mat-focused>
      <mat-label>Name: </mat-label>
      <input matInput formControlName="scoringNameControl" cdkFocusInitial />
      @if (myGroup.get('scoringNameControl').invalid) {
      <mat-error>Name is required.</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="score-value" mat-focused>
      <mat-label>Score: </mat-label>
      <input
        type="number"
        [min]="0"
        matInput
        formControlName="scoringValueFormControl"
        cdkFocusInitial
      />
      @if (myGroup.get('scoringValueFormControl').invalid) {
      <mat-error>Score must be greater or equal to 0.</mat-error>
      }
    </mat-form-field>
  </form>
  <div mat-dialog-actions>
    <div>
      <button mat-button (click)="close()" class="button-close" cdkFocusInitial>
        Cancel
      </button>
      <button
        mat-button
        [disabled]="!myGroup.valid"
        (click)="onUpdateRankingName()"
        class="button-close"
      >
        Save
      </button>
    </div>
  </div>
</div>
